var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    {
      staticClass: "hero is-primary hero-header has-sticky-module-header",
      class: `has-hero-text-${_vm.$theme.name}`,
    },
    [
      _c("div", { staticClass: "hero-body paddingless" }, [
        _c("nav", { staticClass: "navbar" }, [
          _c("div", { staticClass: "navbar-brand" }, [
            _c("div", { staticClass: "navbar-item is-hidden-desktop" }, [
              _c("div", { staticClass: "field is-grouped" }, [
                _c("p", { staticClass: "control" }, [
                  _c(
                    "a",
                    {
                      staticClass:
                        "button tooltip is-tooltip is-tooltip-topleft is-primary",
                      class: _vm.buttonCSS,
                      attrs: {
                        id: "toggle",
                        title: "Toggle Side Menu",
                        "data-tooltip": "Toggle Side Menu",
                      },
                      on: { click: _vm.toggleSide },
                    },
                    [_vm._m(0)]
                  ),
                ]),
                !_vm.licenceExpired &&
                _vm.access.isDelete &&
                !_vm.serviceError &&
                _vm.showCalendar
                  ? _c("p", { staticClass: "control" }, [
                      _c(
                        "a",
                        {
                          staticClass: "button tooltip is-tooltip-topleft",
                          class: _vm.buttonCSS,
                          attrs: {
                            id: "calendar",
                            title: "Calendar",
                            "data-tooltip": "Calendar",
                          },
                          on: { click: _vm.calendar },
                        },
                        [_vm._m(1)]
                      ),
                    ])
                  : _vm._e(),
                !_vm.licenceExpired &&
                _vm.access.isAdd &&
                !_vm.serviceError &&
                _vm.showNew
                  ? _c("p", { staticClass: "control" }, [
                      _c(
                        "a",
                        {
                          staticClass: "button tooltip is-tooltip-topleft",
                          class: _vm.buttonCSS,
                          attrs: {
                            id: "addnew",
                            title: "Add New",
                            "data-tooltip": "Add New",
                          },
                          on: { click: _vm.addNew },
                        },
                        [_vm._m(2)]
                      ),
                    ])
                  : _vm._e(),
                _vm.access.isPrint && !_vm.serviceError && _vm.showPrint
                  ? _c("p", { staticClass: "control" }, [
                      _c(
                        "a",
                        {
                          staticClass: "button tooltip is-tooltip-topleft",
                          class: _vm.buttonCSS,
                          attrs: {
                            id: "print",
                            title: "Print",
                            "data-tooltip": "Print",
                          },
                          on: { click: _vm.print },
                        },
                        [_vm._m(3)]
                      ),
                    ])
                  : _vm._e(),
                !_vm.licenceExpired &&
                _vm.access.isDelete &&
                !_vm.serviceError &&
                _vm.showDelete
                  ? _c("p", { staticClass: "control" }, [
                      _c(
                        "a",
                        {
                          staticClass: "button tooltip is-tooltip-topleft",
                          class: _vm.buttonCSS,
                          attrs: {
                            id: "delete",
                            title: "Delete",
                            "data-tooltip": "Delete",
                          },
                          on: { click: _vm.trash },
                        },
                        [_vm._m(4)]
                      ),
                    ])
                  : _vm._e(),
                !_vm.licenceExpired &&
                _vm.access.isEdit &&
                !_vm.serviceError &&
                _vm.showSave
                  ? _c("p", { staticClass: "control" }, [
                      _c(
                        "a",
                        {
                          staticClass: "button tooltip is-tooltip-topleft",
                          class: _vm.buttonCSS,
                          attrs: {
                            id: "save",
                            title: "Save",
                            "data-tooltip": "Save",
                          },
                          on: { click: _vm.save },
                        },
                        [_vm._m(5)]
                      ),
                    ])
                  : _vm._e(),
                _vm.showCancel
                  ? _c("p", { staticClass: "control" }, [
                      _c(
                        "a",
                        {
                          staticClass: "button tooltip is-tooltip-topleft",
                          class: _vm.buttonCSS,
                          attrs: {
                            id: "cancel",
                            title: "Go Back",
                            "data-tooltip": "Go Back",
                          },
                          on: { click: _vm.cancel },
                        },
                        [_vm._m(6)]
                      ),
                    ])
                  : _vm._e(),
                _vm.showPageCancel
                  ? _c("p", { staticClass: "control" }, [
                      _c(
                        "a",
                        {
                          staticClass: "button tooltip is-tooltip-topleft",
                          class: _vm.buttonCSS,
                          attrs: {
                            id: "pageCancel",
                            title: "Cancel",
                            "data-tooltip": "Cancel",
                          },
                          on: { click: _vm.pageCancel },
                        },
                        [_vm._m(7)]
                      ),
                    ])
                  : _vm._e(),
                _vm.showLock
                  ? _c("p", { staticClass: "control" }, [
                      _c(
                        "a",
                        {
                          staticClass: "button tooltip is-tooltip-topleft",
                          class: _vm.buttonCSS,
                          attrs: {
                            id: "lock",
                            title: "Lock Manage",
                            "data-tooltip": "Lock Manage",
                          },
                          on: { click: _vm.toggleReadOnly },
                        },
                        [
                          _c("span", { staticClass: "icon" }, [
                            _c("span", { staticClass: "msr" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.entity.readOnly ? "lock" : "lock_open"
                                )
                              ),
                            ]),
                          ]),
                        ]
                      ),
                    ])
                  : _vm._e(),
              ]),
            ]),
            _vm._m(8),
          ]),
          _c(
            "div",
            {
              staticClass: "navbar-start is-hidden-touch",
              attrs: { id: "detail-nav-menu" },
            },
            [
              _c("div", { staticClass: "navbar-item" }, [
                _c(
                  "h1",
                  { staticClass: "title has-text-weight-semibold" },
                  [
                    _vm.showToggle
                      ? _c(
                          "a",
                          {
                            staticClass: "button is-primary is-outlined",
                            class: _vm.buttonCSS,
                            staticStyle: { "margin-top": "2px" },
                            on: { click: _vm.toggleSide },
                          },
                          [_vm._m(9)]
                        )
                      : _vm._e(),
                    _vm._l(_vm.$route.matched.slice(), function (route, idx) {
                      return _c("span", { key: idx }, [
                        idx > 0 && route.meta.title
                          ? _c(
                              "span",
                              {
                                staticClass: "icon",
                                staticStyle: {
                                  transform: "translateY(0.5rem)",
                                },
                              },
                              [
                                _c("span", { staticClass: "msr msr-36px" }, [
                                  _vm._v("chevron_right"),
                                ]),
                              ]
                            )
                          : _vm._e(),
                        _c("span", [
                          _vm._v(
                            " " + _vm._s(_vm.title || route.meta.title) + " "
                          ),
                        ]),
                      ])
                    }),
                  ],
                  2
                ),
              ]),
            ]
          ),
          _vm.quoteCancelled
            ? _c(
                "div",
                { staticClass: "navbar-item has-text-centered has-text-white" },
                [_vm._m(10)]
              )
            : _vm._e(),
          _c("div", { staticClass: "navbar-end is-hidden-touch" }, [
            _c("div", { staticClass: "navbar-item" }, [
              _c("div", { staticClass: "field is-grouped" }, [
                !_vm.licenceExpired &&
                _vm.access.isAdd &&
                !_vm.serviceError &&
                _vm.showCalendar
                  ? _c("p", { staticClass: "control" }, [
                      _c(
                        "a",
                        {
                          staticClass: "button",
                          class: _vm.buttonCSS,
                          attrs: { id: "calendar" },
                          on: { click: _vm.calendar },
                        },
                        [_vm._m(11), _c("span", [_vm._v("Calendar")])]
                      ),
                    ])
                  : _vm._e(),
                !_vm.licenceExpired &&
                _vm.access.isAdd &&
                !_vm.serviceError &&
                _vm.showNew
                  ? _c("p", { staticClass: "control" }, [
                      _c(
                        "a",
                        {
                          staticClass: "button",
                          class: _vm.buttonCSS,
                          attrs: { id: "addnew" },
                          on: { click: _vm.addNew },
                        },
                        [_vm._m(12), _c("span", [_vm._v("New")])]
                      ),
                    ])
                  : _vm._e(),
                _vm.access.isPrint &&
                !_vm.serviceError &&
                _vm.showPrint &&
                false
                  ? _c("p", { staticClass: "control" }, [
                      _c(
                        "a",
                        {
                          staticClass: "button",
                          class: _vm.buttonCSS,
                          attrs: { id: "preview" },
                          on: { click: _vm.print },
                        },
                        [_vm._m(13), _c("span", [_vm._v("Preview")])]
                      ),
                    ])
                  : _vm._e(),
                !_vm.licenceExpired &&
                _vm.access.isDelete &&
                !_vm.serviceError &&
                _vm.showDelete &&
                false
                  ? _c("p", { staticClass: "control" }, [
                      _c(
                        "a",
                        {
                          staticClass: "button",
                          class: _vm.buttonCSS,
                          attrs: { id: "delete" },
                          on: { click: _vm.trash },
                        },
                        [_vm._m(14), _c("span", [_vm._v("Delete")])]
                      ),
                    ])
                  : _vm._e(),
                !_vm.licenceExpired &&
                _vm.access.isEdit &&
                !_vm.serviceError &&
                _vm.showConvert
                  ? _c("p", { staticClass: "control" }, [
                      _c(
                        "a",
                        {
                          staticClass: "button",
                          class: _vm.buttonCSS,
                          attrs: { id: "convert" },
                          on: { click: _vm.convert },
                        },
                        [_vm._m(15), _c("span", [_vm._v("Convert")])]
                      ),
                    ])
                  : _vm._e(),
                _vm.showAutoSave
                  ? _c(
                      "div",
                      { staticClass: "is-flex is-align-items-center mx-3" },
                      [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "tippy",
                                rawName: "v-tippy",
                                value: {
                                  content: _vm.autoSaveStatus,
                                  enabled: true,
                                },
                                expression:
                                  "{ content: autoSaveStatus, enabled: true }",
                              },
                            ],
                            staticClass:
                              "text has-text-white-ter is-flex align-items-center is-clickable is-flex-direction-column is-justify-content-center is-align-items-center",
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass:
                                  "material-symbols-outlined fill mr-1",
                                class: {
                                  // 'has-text-success': !isSaving,
                                  loading: _vm.isSaving,
                                  "has-text-danger": _vm.hasAutoSaveFailed,
                                  // 'has-text-warning': unsavedChanges || isSaving
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.isSaving
                                        ? "sync"
                                        : _vm.hasAutoSaveFailed
                                        ? "cloud_off"
                                        : _vm.unsavedChanges
                                        ? "cloud_alert"
                                        : "cloud_done"
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                            _c("span", { staticClass: "is-size-7" }, [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.isSaving
                                      ? "Saving..."
                                      : _vm.hasAutoSaveFailed
                                      ? "Failed"
                                      : _vm.unsavedChanges
                                      ? "Not Saved"
                                      : "Saved"
                                  ) +
                                  " "
                              ),
                            ]),
                          ]
                        ),
                      ]
                    )
                  : _vm._e(),
                !_vm.licenceExpired &&
                _vm.access.isEdit &&
                !_vm.serviceError &&
                _vm.showSave
                  ? _c("p", { staticClass: "control" }, [
                      _c(
                        "a",
                        {
                          staticClass: "button",
                          class: _vm.buttonCSS,
                          attrs: { id: "save" },
                          on: { click: _vm.save },
                        },
                        [_vm._m(16), _c("span", [_vm._v("Save")])]
                      ),
                    ])
                  : _vm._e(),
                _vm.showCancel
                  ? _c("p", { staticClass: "control" }, [
                      _c(
                        "a",
                        {
                          staticClass: "button",
                          class: _vm.buttonCSS,
                          attrs: { id: "cancel" },
                          on: { click: _vm.cancel },
                        },
                        [_vm._m(17), _c("span", [_vm._v("Back")])]
                      ),
                    ])
                  : _vm._e(),
                _vm.showPageCancel
                  ? _c("p", { staticClass: "control" }, [
                      _c(
                        "a",
                        {
                          staticClass: "button",
                          class: _vm.buttonCSS,
                          attrs: { id: "pageCancel" },
                          on: { click: _vm.pageCancel },
                        },
                        [_vm._m(18), _c("span", [_vm._v("Cancel")])]
                      ),
                    ])
                  : _vm._e(),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.showDelete ||
                          _vm.showPrint ||
                          _vm.showLock ||
                          _vm.showQuoteTemplate,
                        expression:
                          "showDelete || showPrint || showLock || showQuoteTemplate",
                      },
                    ],
                    staticClass: "button is-primary px-2",
                    class: `has-hero-button-text-${_vm.$theme.name}`,
                    attrs: { name: "headerMoreButtons" },
                    on: { mouseenter: _vm.handleBurgerButton },
                  },
                  [_vm._m(19)]
                ),
              ]),
            ]),
          ]),
        ]),
      ]),
      _c(
        "tippy",
        {
          ref: "tippyHeaderButtons",
          attrs: {
            to: "headerMoreButtons",
            trigger: "click",
            arrow: "",
            interactive: true,
            theme: `${_vm.$theme.name}`,
            "max-width": 500,
          },
        },
        [
          _c("div", { staticClass: "menu more-menu" }, [
            _c("ul", { staticClass: "menu-list" }, [
              !_vm.licenceExpired &&
              !_vm.serviceError &&
              _vm.showCreditorStatement
                ? _c("li", [
                    _c(
                      "a",
                      {
                        staticClass: "is-flex is-align-items-center",
                        attrs: { id: "viewCreditorStatement" },
                        on: { click: _vm.viewCreditorStatement },
                      },
                      [
                        _c("span", { staticClass: "icon pr-3" }, [
                          _c("span", { staticClass: "msr msr-20px" }, [
                            _vm._v("request_page"),
                          ]),
                        ]),
                        _c("span", [_vm._v("View Creditor Statement")]),
                      ]
                    ),
                  ])
                : _vm._e(),
              !_vm.licenceExpired &&
              !_vm.serviceError &&
              _vm.showDebtorStatement
                ? _c("li", [
                    _c(
                      "a",
                      {
                        staticClass: "is-flex is-align-items-center",
                        attrs: { id: "viewDebtorStatement" },
                        on: { click: _vm.viewDebtorStatement },
                      },
                      [
                        _c("span", { staticClass: "icon pr-3" }, [
                          _c("span", { staticClass: "msr msr-20px" }, [
                            _vm._v("request_page"),
                          ]),
                        ]),
                        _c("span", [_vm._v("View Debtor Statement")]),
                      ]
                    ),
                  ])
                : _vm._e(),
              !_vm.licenceExpired &&
              !_vm.serviceError &&
              _vm.showAdvancePaymentEntry
                ? _c("li", [
                    _c(
                      "a",
                      {
                        staticClass: "is-flex is-align-items-center",
                        attrs: { id: "viewAdvancePaymentEntry" },
                        on: { click: _vm.viewAdvancePaymentEntry },
                      },
                      [
                        _c("span", { staticClass: "icon pr-3" }, [
                          _c("span", { staticClass: "msr msr-20px" }, [
                            _vm._v("request_page"),
                          ]),
                        ]),
                        _c("span", [_vm._v("Advance Payment Entry")]),
                      ]
                    ),
                  ])
                : _vm._e(),
              !_vm.licenceExpired &&
              !_vm.serviceError &&
              _vm.showAdvanceReceiptEntry
                ? _c("li", [
                    _c(
                      "a",
                      {
                        staticClass: "is-flex is-align-items-center",
                        attrs: { id: "viewAdvanceReceiptEntry" },
                        on: { click: _vm.viewAdvanceReceiptEntry },
                      },
                      [
                        _c("span", { staticClass: "icon pr-3" }, [
                          _c("span", { staticClass: "msr msr-20px" }, [
                            _vm._v("request_page"),
                          ]),
                        ]),
                        _c("span", [_vm._v("Advance Receipt Entry")]),
                      ]
                    ),
                  ])
                : _vm._e(),
              !_vm.licenceExpired && !_vm.serviceError && _vm.showFactorInvoice
                ? _c("li", [
                    _c(
                      "a",
                      {
                        staticClass: "is-flex is-align-items-center",
                        attrs: { id: "factorInvoice" },
                        on: { click: _vm.factorInvoice },
                      },
                      [
                        _c("span", { staticClass: "icon pr-3" }, [
                          _c("span", { staticClass: "msr msr-20px" }, [
                            _vm._v("receipt_long"),
                          ]),
                        ]),
                        _c("span", [_vm._v("Factor Invoices")]),
                      ]
                    ),
                  ])
                : _vm._e(),
              !_vm.licenceExpired &&
              !_vm.serviceError &&
              _vm.showFactorSelectedInvoice
                ? _c("li", [
                    _c(
                      "a",
                      {
                        staticClass: "is-flex is-align-items-center",
                        attrs: { id: "factorSelectedInvoice" },
                        on: { click: _vm.factorSelectedInvoice },
                      },
                      [
                        _c("span", { staticClass: "icon pr-3" }, [
                          _c("span", { staticClass: "msr msr-20px" }, [
                            _vm._v("receipt_long"),
                          ]),
                        ]),
                        _c("span", [_vm._v("Factor Selected Invoices")]),
                      ]
                    ),
                  ])
                : _vm._e(),
              !_vm.licenceExpired &&
              !_vm.serviceError &&
              _vm.showBankUnDepositedFunds
                ? _c("li", [
                    _c(
                      "a",
                      {
                        staticClass: "is-flex is-align-items-center",
                        attrs: { id: "viewBankUnDepositedFunds" },
                        on: { click: _vm.viewBankUnDepositedFunds },
                      },
                      [
                        _c("span", { staticClass: "icon pr-3" }, [
                          _c("span", { staticClass: "msr msr-20px" }, [
                            _vm._v("account_balance"),
                          ]),
                        ]),
                        _c("span", [_vm._v("Bank Un-Deposited Funds")]),
                      ]
                    ),
                  ])
                : _vm._e(),
              _vm.access.isPrint && !_vm.serviceError && _vm.showPrint
                ? _c("li", [
                    _c(
                      "a",
                      {
                        staticClass: "is-flex is-align-items-center",
                        attrs: { id: "preview" },
                        on: { click: _vm.print },
                      },
                      [
                        _c("span", { staticClass: "icon pr-3" }, [
                          _c("span", { staticClass: "msr msr-20px" }, [
                            _vm._v("print"),
                          ]),
                        ]),
                        _c("span", [_vm._v("Preview")]),
                      ]
                    ),
                  ])
                : _vm._e(),
              !_vm.licenceExpired && !_vm.serviceError && _vm.showLock
                ? _c("li", [
                    _c(
                      "a",
                      {
                        staticClass: "is-flex is-align-items-center",
                        attrs: { id: "lock" },
                        on: { click: _vm.toggleReadOnly },
                      },
                      [
                        _c("span", { staticClass: "icon pr-3" }, [
                          _c("span", { staticClass: "msr msr-20px" }, [
                            _vm._v(
                              _vm._s(_vm.entity.readOnly ? "lock" : "lock_open")
                            ),
                          ]),
                        ]),
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.entity.readOnly ? "Unlock" : "Lock")
                          ),
                        ]),
                      ]
                    ),
                  ])
                : _vm._e(),
              !_vm.serviceError && _vm.showPricePartsMsg
                ? _c("li", [
                    _c(
                      "a",
                      {
                        staticClass: "is-flex is-align-items-center",
                        attrs: { id: "priceparts" },
                        on: { click: _vm.viewPricePartsMsg },
                      },
                      [
                        _c("span", { staticClass: "icon pr-3" }, [
                          _c("span", { staticClass: "msr msr-20px" }, [
                            _vm._v("chat"),
                          ]),
                        ]),
                        _c("span", [_vm._v("View Price Parts Messages")]),
                      ]
                    ),
                  ])
                : _vm._e(),
              !_vm.licenceExpired &&
              _vm.access.isEdit &&
              !_vm.serviceError &&
              _vm.showAdditionalQuoteButtons &&
              _vm.showAdditionalQuote
                ? _c("li", [
                    _c(
                      "a",
                      {
                        staticClass: "is-flex is-align-items-center pl-1",
                        attrs: { id: "new_additional_quote" },
                        on: { click: _vm.newAdditionalQuote },
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "material-symbols-rounded mr-1",
                            staticStyle: { "font-size": "20px" },
                          },
                          [_vm._v(" add ")]
                        ),
                        _c("span", [_vm._v("New Additional Quote")]),
                      ]
                    ),
                  ])
                : _vm._e(),
              !_vm.licenceExpired &&
              _vm.access.isEdit &&
              !_vm.serviceError &&
              _vm.showAdditionalQuoteButtons
                ? _c("li", [
                    _c(
                      "a",
                      {
                        staticClass: "is-flex is-align-items-center pl-1",
                        attrs: { id: "copy_quote" },
                        on: { click: _vm.copyQuote },
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "material-symbols-rounded mr-1",
                            staticStyle: { "font-size": "20px" },
                          },
                          [_vm._v(" content_copy ")]
                        ),
                        _c("span", [_vm._v("Copy Quote")]),
                      ]
                    ),
                  ])
                : _vm._e(),
              !_vm.licenceExpired &&
              _vm.access.isEdit &&
              !_vm.serviceError &&
              _vm.showAdditionalQuoteButtons
                ? _c("li", [
                    _c(
                      "a",
                      {
                        staticClass: "is-flex is-align-items-center pl-1",
                        attrs: { id: "export_quote" },
                        on: { click: _vm.exportQuote },
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "material-symbols-rounded mr-1",
                            staticStyle: { "font-size": "20px" },
                          },
                          [_vm._v(" file_export ")]
                        ),
                        _c("span", [_vm._v("Export Quote")]),
                      ]
                    ),
                  ])
                : _vm._e(),
              !_vm.licenceExpired && !_vm.serviceError && _vm.showQuoteTemplate
                ? _c("li", [
                    !_vm.quoteTemplateDisabled
                      ? _c("div", [
                          _c(
                            "a",
                            {
                              staticClass: "is-flex is-align-items-center",
                              attrs: { id: "quoteTemplate" },
                              on: { click: _vm.saveTemplateFromQuote },
                            },
                            [
                              _c("span", { staticClass: "icon pr-3" }, [
                                _c("span", { staticClass: "msr msr-20px" }, [
                                  _vm._v("add"),
                                ]),
                              ]),
                              _c("span", [_vm._v("Save as Template")]),
                            ]
                          ),
                        ])
                      : _c("div", [
                          _c(
                            "button",
                            {
                              staticClass:
                                "is-flex is-align-items-center button is-white is-fullwidth pl-0 is-justify-content-flex-start",
                              attrs: {
                                id: "quoteTemplate",
                                disabled: _vm.quoteTemplateDisabled,
                              },
                            },
                            [
                              _c("span", { staticClass: "icon ml-0" }, [
                                _c("span", { staticClass: "msr msr-20px" }, [
                                  _vm._v("print"),
                                ]),
                              ]),
                              _c("span", [_vm._v("Save as Template")]),
                            ]
                          ),
                        ]),
                  ])
                : _vm._e(),
              !_vm.licenceExpired &&
              _vm.access.isDelete &&
              !_vm.serviceError &&
              _vm.showDelete &&
              _vm.showPrint
                ? _c("div", { staticClass: "is-divider" })
                : _vm._e(),
              !_vm.licenceExpired &&
              _vm.access.isDelete &&
              !_vm.serviceError &&
              _vm.showDelete
                ? _c("li", [
                    _c(
                      "a",
                      {
                        staticClass:
                          "has-text-danger is-flex is-align-items-center",
                        attrs: { id: "delete" },
                        on: { click: _vm.trash },
                      },
                      [
                        _c("span", { staticClass: "icon pr-3" }, [
                          _c("span", { staticClass: "msr msr-20px" }, [
                            _vm._v("delete"),
                          ]),
                        ]),
                        _c("span", [_vm._v("Delete")]),
                      ]
                    ),
                  ])
                : _vm._e(),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("span", { staticClass: "msr" }, [_vm._v("menu")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-calendar" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("span", { staticClass: "msr" }, [_vm._v("add")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("span", { staticClass: "msr" }, [_vm._v("print")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("span", { staticClass: "msr" }, [_vm._v("delete")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("span", { staticClass: "msr" }, [_vm._v("save")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("span", { staticClass: "msr" }, [_vm._v("arrow_back")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("span", { staticClass: "msr" }, [_vm._v("cancel")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass: "navbar-burger burger",
        attrs: { "data-target": "action-button-menu" },
      },
      [_c("span"), _c("span"), _c("span")]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("span", { staticClass: "msr msr-24px" }, [_vm._v("menu")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "is-size-6 tag is-danger is-light" }, [
      _c("span", { staticClass: "mdi mdi-alert-outline mr-3" }),
      _vm._v(
        " Cancelled by insurer. Please copy the quote to work on it as a private job."
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-calendar mdi-18px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("span", { staticClass: "msr msr-18px" }, [_vm._v("add")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("span", { staticClass: "msr msr-18px" }, [_vm._v("print")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("span", { staticClass: "msr msr-18px" }, [_vm._v("delete")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-swap-horizontal mdi-18px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("span", { staticClass: "msr msr-18px" }, [_vm._v("save")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("span", { staticClass: "msr msr-18px" }, [_vm._v("arrow_back")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("span", { staticClass: "msr msr-18px" }, [_vm._v("cancel")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("span", { staticClass: "msr msr-36px" }, [_vm._v("more_vert")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }